import React, { useState } from 'react';
import {
    View,
    StyleSheet,
    Image,
    TouchableHighlight,
    TouchableOpacity,
    Button,
    Platform,
} from 'react-native';
import { StackActions } from '@react-navigation/native';
import { useSelector } from 'react-redux';
import Screen from './../components/shared/Screen';
import Icon from '../components/shared/Icon';
import ItemSeparator from './../components/shared/ItemSeparator';
import AsyncStorage from '@react-native-async-storage/async-storage';
import ToplearnText from './../components/shared/ToplearnText';
import * as DocumentPicker from 'expo-document-picker';
import * as FileSystem from 'expo-file-system';
import UploadFiles from '../components/shared/UploadFiles'

import axios from 'axios';
import FormData from 'form-data';

const AccountScreen = ({ navigation }) => {
    const user = useSelector((state) => state.user);
    const [prc, setPrc] = useState(0);
    const [shwProgress, setShwProgress] = useState(false);

    const handleLogout = async () => {
        await AsyncStorage.removeItem('token');
        await AsyncStorage.removeItem('userId');
        navigation.dispatch(StackActions.replace('Welcome'));
    };


    return (
        <Screen style={styles.screen}>
            <View style={styles.container}>
                <Image
                    style={styles.image}
                    source={require('../assets/person.png')}
                />
                <View style={styles.details}>
                    <ToplearnText fontFamily="ih" size="1.6">
                        {user.firstName} {user.lastName}
                    </ToplearnText>
                    <ToplearnText
                        fontFamily="yekan"
                        size="1.5"
                        styles={styles.subTitle}
                    >
                        {user.shenaseh}
                    </ToplearnText>
                </View>
                {/* <TouchableOpacity onPress={() => {}} style={styles.settings}>
                    <Icon name="settings" backgroundColor="tomato" />
                </TouchableOpacity> */}
            </View>
            <ItemSeparator height={10} />
            <TouchableHighlight underlayColor="#f8f4f4" onPress={handleLogout}>
                <View style={styles.container}>
                    <Icon name="logout" backgroundColor="tomato" />
                    <View style={styles.details}>
                        <ToplearnText fontFamily="ih" size="2">
                            خروج از حساب کاربری
                        </ToplearnText>
                    </View>
                </View>
            </TouchableHighlight>
            {(user.isAdmin)&&(Platform.OS==='web') ? (
                <View style={{ width: "600px" }}>
                    {/* <Button title="Select Document" onPress={pickDocument} />
                    <Button title="Upload" onPress={postDocument} /> */}
                    <UploadFiles />
                </View>
            ) : // <TouchableHighlight
            //     underlayColor="#f8f4f4"
            //     onPress={pickDocument}
            // >
            //     <View style={styles.container}>
            //         <Icon
            //             name="file-upload-outline"
            //             backgroundColor="tomato"
            //         />
            //         <View style={styles.details}>
            //             <ToplearnText fontFamily="ih" size="2">
            //                 آپلود فایل ماهانه
            //             </ToplearnText>
            //         </View>
            //     </View>
            // </TouchableHighlight>
            null}
        </Screen>
    );
};

export default AccountScreen;

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        // marginVertical: 0,
        padding: 15,
    },
    screen: {
        backgroundColor: '#f8f4f4',
    },
    image: {
        width: 100,
        height: 100,
        borderRadius: 35,
    },
    details: {
        marginLeft: 10,
        justifyContent: 'center',
    },
    subTitle: {
        color: '#6e6969',
    },
    settings: {
        alignSelf: 'center',
        marginLeft: 20,
    },
});
